<template>
  <div>
    <div class="my-bottom-div">
      <el-row>
        <el-col :span="12">
          <div class="my-bottom-div1">
            <router-link to="/"><span class="my-bottom-span">网站首页</span></router-link>
            <router-link to="/summarized"><span class="my-bottom-span">公司简介</span></router-link>
            <router-link to="/item/index"><span class="my-bottom-span">产品展示</span></router-link>
            <router-link to="/news/index"><span class="my-bottom-span">新闻中心</span></router-link>
          </div>
          <div class="my-bottom-div2">
            <router-link to="/aftermarket"><span class="my-bottom-span">售后服务</span></router-link>
            <router-link to="/message"><span class="my-bottom-span">留言反馈</span></router-link>
            <router-link to="/contact"><span class="my-bottom-span">联系我们</span></router-link>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="my-bottom-div3">
            <div>
              <img style="width: 326px;height:80px" :src="getInfo.logoUrl" fit="fill" :name="index.name" :label="index.name"></img><br />
            </div>
            <div style="text-align: right;">
              <span class="my-bottom-span1">武汉洛克</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div><br />
    <div>
      <span class="my-bottom-span2">武汉洛克粉磨设备制造有限公司 Corporation. 邮编：{{getInfo.postalCode}} E-mail：{{getInfo.email}}</span><br />
      <span class="my-bottom-span2">地址：{{getInfo.address}}　电话：{{getInfo.phone}} 传真：{{getInfo.phone}}</span><br />
      <span class="my-bottom-span2">销售经理：{{getInfo.telephone}} {{getInfo.name}} </span><br />
      <span><img src="@/assets/2.png" height="20px" width="20px" onclick="javascript:location.href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42011202001786'"></span>
      <span style="font-size: 14px;"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42011202001786" style="color: black; text-decoration:none;">鄂公网安备42011202001786号</a></span>
      <span>&nbsp;&nbsp;</span>
      <span style="font-size: 14px;"><a href="http://www.beian.miit.gov.cn/" style="color: black; text-decoration:none;">鄂ICP备10009908号</a></span>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex'

  export default {
    name: 'Bottom',
    data: function() {
      return {
        index: {
          name: "logo",
        },
      }
    },
    methods: {

    },
    computed: {
      ...Vuex.mapGetters(["getInfo"])
    }
  }
</script>

<style>
  .my-bottom-div {
    width: 1200px;
    height: 130px;
    margin: 0 auto;
    background-color: #D3D4D6;
  }

  .my-bottom-div1 {
    position: relative;
    right: 80px;
    top: 30px;
  }

  .my-bottom-div2 {
    position: relative;
    right: 118px;
    top: 50px;
  }

  .my-bottom-div3 {
    float: right;
  }

  .my-bottom-span {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
  }

  .my-bottom-span2 {
    color: #000000;
    font-size: 14px;
    font-weight: bold;
  }

  .my-bottom-div1>a {
    text-decoration: none;
  }

  .my-bottom-div2>a {
    text-decoration: none;
  }

  .my-bottom-span1 {
    color: royalblue;
    font-size: 36px;
    width: 100%;
    font-weight: bold;
    position: relative;
    right: 10px;
    bottom: 10px;
  }

  .router-link-active {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Bottom.vue